import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "align-top" }
const _hoisted_2 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "align-top" }
const _hoisted_9 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_10 = { class: "input-group date datepickerInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = { class: "align-top text-center" }
const _hoisted_14 = {
  key: 0,
  class: "form-check form-check-inline pt-3"
}
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "is-present-on-admission"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "text-end"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-up" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "button-cell text-end"
}
const _hoisted_28 = {
  key: 2,
  class: "button-cell text-end"
}
const _hoisted_29 = {
  key: 3,
  class: "text-end"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", null, "Problem Resolution in Progress", -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["colspan"]
const _hoisted_33 = {
  key: 0,
  class: "row-no-hover edit-row"
}
const _hoisted_34 = ["colspan"]
const _hoisted_35 = { class: "d-flex flex-column align-items-center" }
const _hoisted_36 = { class: "form-group w-25 mb-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "resolution-date" }, " Resolution Date ", -1 /* HOISTED */)
const _hoisted_38 = { class: "input-group date datepickerInput" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isResolveRequested || _ctx.isAddRequested || _ctx.isDeleteRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", _hoisted_1, [
        (_ctx.isEditRequested || _ctx.isAddRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getProblemsList,
                value: _ctx.selectedProblem,
                placeholder: "Search for Problem",
                "init-value": _ctx.selectedProblem,
                disabled: _ctx.isEditRequested,
                onValueChanged: _ctx.selectedProblemChanged
              }, null, 8 /* PROPS */, ["getData", "value", "init-value", "disabled", "onValueChanged"])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (_ctx.problem?.description)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.problem.description), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("small", _hoisted_5, _hoisted_7))
            ]))
      ]),
      _createElementVNode("td", _hoisted_8, [
        (_ctx.isEditRequested || _ctx.isAddRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      name: "startDate",
                      type: "text",
                      class: "form-control",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.problem?.onsetDate),
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDate && _ctx.handleDate(...args))),
                      autocomplete: "off"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11),
                    _hoisted_12
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["getDate"])
            ]))
          : (_openBlock(), _createBlock(_component_EmptyTextHandler, {
              key: 1,
              text: _ctx.problem?.onsetDate
            }, null, 8 /* PROPS */, ["text"]))
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.problem?.lastAddressedOn
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", _hoisted_13, [
        (_ctx.isEditRequested || _ctx.isAddRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input ms-5",
                id: "is-present-on-admission",
                checked: _ctx.problem.isPresentOnAdmission,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleIsPresentOnAdmission()))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
              _hoisted_16
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.problem.isPresentOnAdmission ? "Yes" : "No"), 1 /* TEXT */))
      ]),
      (!_ctx.isEditRequested && !_ctx.isResolveRequested && !_ctx.isAddRequested && !_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
            (!_ctx.first)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn table-btn btn-outline-info me-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveProblemUp(_ctx.index, _ctx.index - 1)))
                }, _hoisted_20)), [
                  [_directive_tooltip, { title: 'Move Problem Up' }]
                ])
              : _createCommentVNode("v-if", true),
            (!_ctx.last)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn table-btn btn-outline-info me-1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveProblemDown(_ctx.index, _ctx.index + 1)))
                }, _hoisted_22)), [
                  [_directive_tooltip, { title: 'Move Problem Down' }]
                ])
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "btn table-btn btn-outline-info",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openResolveProblem(_ctx.index)))
            }, "Resolve"),
            _createElementVNode("button", {
              class: "btn table-btn btn-outline-info",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openEditProblem()))
            }, _hoisted_24),
            _createElementVNode("button", {
              class: "btn table-btn btn-outline-danger",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openDeleteProblem()))
            }, _hoisted_26)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isEditRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-success",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveEditProblem()))
            }, "Add"),
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-secondary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancelEditProblem()))
            }, " Cancel ")
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-success",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save()))
            }, "Add"),
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelSaveNewProblem()))
            }, " Cancel ")
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isResolveRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_29, _hoisted_31))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", {
            key: 4,
            colspan: _ctx.columns,
            class: "p-2 text-end"
          }, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "Yes, Delete",
              name: "delete",
              ok: _ctx.deleteProb,
              cancel: _ctx.cancelDeleteRequest,
              message: _ctx.deleteMessage,
              "cancel-text": "No",
              "include-yes": false
            }, null, 8 /* PROPS */, ["ok", "cancel", "message"])
          ], 8 /* PROPS */, _hoisted_32))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_ctx.isResolveRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-2 edit"
          }, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_DatePicker, {
                  options: _ctx.resolveDatePickerOptions,
                  getDate: _ctx.handleDateChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("input", {
                        name: "resolvedDate",
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.resolvedDate),
                        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleDate && _ctx.handleDate(...args))),
                        autocomplete: "off",
                        "date-format-only": ""
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_39),
                      _hoisted_40
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["options", "getDate"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-xs btn-outline-primary me-1",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveResolveProblem(_ctx.index)))
                }, "Save"),
                _createElementVNode("button", {
                  class: "btn btn-xs btn-outline-secondary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelResolveProblem(_ctx.index)))
                }, " Cancel ")
              ])
            ])
          ], 8 /* PROPS */, _hoisted_34)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}